import { createContext, useEffect } from "react";
import { useState } from "react";

import { useSearchParams } from "react-router-dom";

export const LocationFilteredDeckRankingTabContext = createContext(null);

export function LocationFilteredDeckRankingTabProvider({ children }) {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [currentStartDate, setCurrentStartDate] = useState(null);
  const [currentEndDate, setCurrentEndDate] = useState(null);
  const [currentSelectedDivisions, setCurrentSelectedDivisions] =
    useState(null);
  const [currentLanguage, setCurrentLanguage] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const urlPrefecture = searchParams.get("prefecture");
  const urlOrganizer = searchParams.get("organizer");

  const [prefecture, setPrefecture] = useState(urlPrefecture || null);
  const [organizer, setOrganizer] = useState(urlOrganizer || null);

  useEffect(() => {
    if (urlPrefecture || urlOrganizer) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("prefecture");
      newParams.delete("organizer");
      newParams.delete("open");
      setSearchParams(newParams, { replace: true });
    }
  }, [urlPrefecture, urlOrganizer, searchParams, setSearchParams]);

  return (
    <LocationFilteredDeckRankingTabContext.Provider
      value={{
        error,
        setError,
        items,
        setItems,
        currentStartDate,
        setCurrentStartDate,
        currentEndDate,
        setCurrentEndDate,
        currentSelectedDivisions,
        setCurrentSelectedDivisions,
        currentLanguage,
        setCurrentLanguage,
        prefecture,
        setPrefecture,
        organizer,
        setOrganizer,
      }}
    >
      {children}
    </LocationFilteredDeckRankingTabContext.Provider>
  );
}
